export const HEADER = {
   HOME: {
       title : "Home",
       url:""
    },
   PRODUCT: {
       title: "Products",
       subSection: [{
           title: "API Products",
           url: ""
       }]
   }, 
   SUPPORT : {
       title: "Support",
    }
}